import FavoriteCourseAPI from '@/apis/business/student/favorite-course-api.js'
import enumeration from '@/common/enumeration'

export default {
  namespaced: true,
  state: {

    // TODO đây là phần state của exercise reference
    totalFavoriteCourse: 0, // Tổng số bài tập từ kho học liệu yêu thích
    listFavoriteCourses: [], // Bài tập từ kho học liệu yêu thích
    isFavoritedCourse: false, // Đánh dấu học liệu đã được yêu thích
    appendFavoriteExercisesOld: [],
    appendFavoriteExercises: [],
    favoriteTabFilter: { // Tham số cho query filter tab quan tâm, màn hình học liệu yêu thích
      myCourseStatus: enumeration.LibraryCourseType.All, // Môn
      subjectCode: '', // Môn
      queryText: '' // Text tìm kiếm
    }
  },

  getters: {},

  mutations: {
    /**
     * set list Course
     * CreateBy: VHSON 17.11
     */
    setListFavoriteCourses (state, listFavoriteCourses) {
      state.listFavoriteCourses = listFavoriteCourses
    },

    /**
     * set list Course
     * CreateBy: VHSON 17.11
     */
    setTotalFavoriteCourse (state, totalFavoriteCourse) {
      state.totalFavoriteCourse = totalFavoriteCourse
    },

    /**
     * set list Course
     * CreateBy: VHSON 17.11
     */
    setFavoritedCourse (state, isFavoritedCourse) {
      state.isFavoritedCourse = isFavoritedCourse
    },

    // Réet danh sách học liệu yêu thích
    setFavoriteExercisesToEmpty (state) {
      state.appendFavoriteExercisesOld = []
      state.appendFavoriteExercises = []
    },

    // append danh sách học liệu Yêu thích
    setAppendFavoriteExercises (state, appendFavoriteExercises) {
      state.appendFavoriteExercisesOld = [...appendFavoriteExercises]
      state.appendFavoriteExercises = state.appendFavoriteExercises.concat(state.appendFavoriteExercisesOld)
    }
  },

  actions: {

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     * @author VHSON
     */
    getFilterFavoriteCourse (context, exerciseLibrary) {
      const query =
            `sourceType=${exerciseLibrary.sourceType}` +
            `&gradeID=${exerciseLibrary.gradeID ? exerciseLibrary.gradeID : ''}` +
            `&subjectID=${exerciseLibrary.subjectID ? exerciseLibrary.subjectID : ''}` +
            `&takeCharge=${exerciseLibrary.takeCharge ? exerciseLibrary.takeCharge : ''}` +
            `&queryText=${exerciseLibrary.queryText ? exerciseLibrary.queryText : ''}` +
            `&pageIndex=${exerciseLibrary.pageIndex ? exerciseLibrary.pageIndex : ''}` +
            `&pageSize=${exerciseLibrary.pageSize ? exerciseLibrary.pageSize : ''}`
      return new Promise((resolve, reject) => {
        FavoriteCourseAPI.getAsync('favorite-courses?' + query)
          .then((res) => {
            context.commit('setListFavoriteCourses', res.Data?.PageData)
            context.commit('setTotalFavoriteCourse', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Thêm 1 học liệu vào bảng FavoriteCourse
     * @param {*} context
     * @param {*} params
     * @returns
     */
    postFavoriteCourse (context, params) {
      return new Promise((resolve, reject) => {
        FavoriteCourseAPI.postAsync('course-param', params)
          .then((res) => {
            context.commit('setFavoritedCourse', true)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @param {*} courseId
     * @returns
     * @author VHSON
     */
    checkFavoriteCourse (context, courseId) {
      const query =
            `courseID=${courseId}`
      return new Promise((resolve, reject) => {
        FavoriteCourseAPI.getAsync('check-is-favorite?' + query)
          .then((res) => {
            context.commit('setFavoritedCourse', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Thêm 1 học liệu vào bảng FavoriteCourse
     * @param {*} context
     * @param {*} params
     * @returns
     */
    deleteFavoriteCourse (context, params) {
      const query =
      `courseID=${params}`
      return new Promise((resolve, reject) => {
        FavoriteCourseAPI.postAsync('delete-course-param?' + query)
          .then((res) => {
            context.commit('setFavoritedCourse', false)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy toàn bộ thư viện học liệu tham khảo của MISA
     * @param {} context
     * @returns
     * @author VHSON
     */
    getFavoriteExerciseTab (context, params) {
      const query =
      `status=${params.status}` +
      `&subjectCode=${params.subjectCode ? params.subjectCode : ''}` +
      `&queryText=${params.queryText ? params.queryText : ''}` +
      `&pageIndex=${params.pageIndex ? params.pageIndex : ''}` +
      `&pageSize=${params.pageSize ? params.pageSize : ''}`
      return new Promise((resolve, reject) => {
        FavoriteCourseAPI.getAsync('course-favorite-list?' + query)
          .then((res) => {
            context.commit('setAppendFavoriteExercises', res.Data?.PageData)
            context.commit('setTotalFavoriteCourse', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }

}
